PJQ.models.rawFileUploads = {};

PJQ.models.rawFileUploads.RawFileUpload = PJQ.models.BaseModel.extend({
    idAttribute: 'rawFileUploadId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'rawfileuploads',
                value: this.id
            }
        ]);
    }
});
